// removed by extract-text-webpack-plugin
module.exports = {"loading-spinner":"_23xDqUwDN _2YtaLMokc _1Kb3c6aeJ _3U3xLmGzS _3dDRJkqHt _1pZUMAGmH _3UjnovSKS _6rexmpxuB"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/loading-spinner/loading-spinner.css
 ** module id = 2141
 ** module chunks = 0
 **/